import React, { MouseEventHandler } from 'react';
import { Box, Button, Text } from '@doda/io-react/common';
import styles from './index.module.scss';

/**
 * AgentService コンポーネントのプロパティ
 */
export interface Props {
  /** ボタンのリンク先URL */
  href: string;
  /** ボタンがクリックされたときのハンドラー（任意） */
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}

/**
 * AgentService コンポーネント
 * @param {Props} props - AgentService コンポーネントのプロパティ
 * @returns {JSX.Element} レンダリングされたコンポーネント
 */
export const AgentService: React.FC<Props> = ({ href, onClick }) => {
  return (
    <Box className={styles.agentService__wrapper}>
      <Button
        as="a"
        href={href}
        onClick={onClick}
        variant="orange"
        size="L"
        style={{ width: '444px', textDecoration: 'none', marginBottom: '16px' }}
      >
        <span> エージェントサービスに申し込む（無料）</span>
      </Button>
      <Text color="gray">
        サイトに掲載されていない非公開求人を見るにはエージェントサービスに申し込みが必要です
      </Text>
    </Box>
  );
};
